import { render, staticRenderFns } from "./SubjectDetails.vue?vue&type=template&id=539f2b48&scoped=true&"
import script from "./SubjectDetails.vue?vue&type=script&lang=js&"
export * from "./SubjectDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539f2b48",
  null
  
)

export default component.exports